import React from "react";
import { Link } from "react-router-dom";
import { Lock, Loader2, ArrowRight, LogOut } from "lucide-react";

/**
 * Small chrome components for /corso/lezione/:n — header, full-screen loader,
 * error, and the "locked lesson" gate.
 */
export function LessonHeader({ user, onLogout }) {
  return (
    <header className="border-b" style={{ background: "var(--np-quaternary)", borderColor: "rgba(26,42,58,0.06)" }}>
      <div className="mx-auto px-6 md:px-10 py-2.5 flex items-center justify-between" style={{ maxWidth: 1280 }}>
        <Link to="/" className="inline-flex items-center">
          <img
            src="https://customer-assets.emergentagent.com/job_ciclo-responsabilita/artifacts/ypgcjh4z_11%20%2829%29.png"
            alt="Neuroscienza Pratica"
            className="block"
            style={{
              width: "clamp(220px, 24vw, 380px)",
              aspectRatio: "4 / 1",
              objectFit: "cover",
              objectPosition: "center",
            }}
          />
        </Link>
        <div className="flex items-center gap-3">
          <span className="hidden sm:block text-sm" style={{ color: "var(--np-muted)" }}>
            Ciao, <strong style={{ color: "var(--np-primary)" }}>{user?.name?.split(" ")[0] || "studente"}</strong>
          </span>
          <button
            onClick={onLogout}
            className="inline-flex items-center gap-1.5 px-3 py-2 rounded-full text-xs font-semibold border transition hover:bg-white"
            style={{ color: "var(--np-primary)", borderColor: "#dbe3ec" }}
          >
            <LogOut size={13} /> Esci
          </button>
        </div>
      </div>
    </header>
  );
}

export function FullScreenLoading() {
  return (
    <div className="min-h-screen flex items-center justify-center" style={{ background: "var(--np-tertiary)" }}>
      <Loader2 className="animate-spin" size={26} style={{ color: "var(--np-secondary)" }} />
    </div>
  );
}

export function FullScreenError({ msg }) {
  return (
    <div className="min-h-screen flex items-center justify-center px-6" style={{ background: "var(--np-tertiary)" }}>
      <p className="text-center" style={{ color: "var(--np-primary)", fontFamily: "Merriweather, serif" }}>{msg}</p>
    </div>
  );
}

export function LockedLessonScreen({ n }) {
  return (
    <div className="min-h-screen flex items-center justify-center px-6" style={{ background: "var(--np-tertiary)" }}>
      <div className="max-w-md w-full bg-white rounded-2xl shadow-[0_30px_80px_-30px_rgba(26,42,58,0.35)] p-8 text-center">
        <div className="w-14 h-14 rounded-2xl flex items-center justify-center mx-auto mb-5" style={{ background: "var(--np-quaternary)" }}>
          <Lock size={24} style={{ color: "var(--np-secondary)" }} />
        </div>
        <h1 className="text-2xl" style={{ color: "var(--np-primary)", fontFamily: "Merriweather, serif" }}>
          Lezione {n} ancora bloccata
        </h1>
        <p className="mt-3 text-sm" style={{ color: "var(--np-muted)" }}>
          Completa la lezione precedente per sbloccare questa.
        </p>
        <Link to={`/corso/lezione/${n - 1}`} className="cta-btn mt-7 inline-flex">
          Torna alla Lezione {n - 1} <ArrowRight size={16} />
        </Link>
      </div>
    </div>
  );
}
